import React from 'react';

type DateInputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * Native date input that reliably opens the picker on mobile tap
 * (Safari / Chrome often need showPicker(); spacebar alone is not enough).
 */
export function DateInput({ className, onClick, onFocus, ...rest }: DateInputProps) {
  const openPicker = (el: HTMLInputElement) => {
    try {
      if (typeof el.showPicker === 'function') {
        el.showPicker();
      }
    } catch {
      // showPicker can throw if not triggered by a user gesture or unsupported.
    }
  };

  return (
    <input
      {...rest}
      type="date"
      className={className}
      onFocus={(e) => {
        openPicker(e.currentTarget);
        onFocus?.(e);
      }}
      onClick={(e) => {
        openPicker(e.currentTarget);
        onClick?.(e);
      }}
    />
  );
}
